const env = process.env.NODE_ENV

const domainName = 'http://www.ewangke.com'

const URL = `${domainName}/api/apiv`
const URLEnduser = `${domainName}/api/enduser`
const URLIntegral = `${domainName}/api/integral`
const imgUrl = domainName
const weChat = `${domainName}/api`

let baseURL = env == 'development' ? URL : URL

export default { baseURL, imgUrl, URLEnduser, URLIntegral, weChat, domainName }



// WEBPACK FOOTER //
// ./src/axios/baseUrl.js